import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, BarChart3Icon, ShieldCheckIcon, UserCheckIcon } from 'lucide-react';
export function Philosophy() {
  const principles = [{
    icon: CheckCircleIcon,
    title: 'Every Deal Is Curated',
    description: 'Quality over quantity. Not every property makes our list. We analyze hundreds of opportunities and surface only those with compelling fundamentals and verifiable data.'
  }, {
    icon: BarChart3Icon,
    title: 'Data Is the Language',
    description: 'Cash flow percentage, ROI, equity multiple, cap rate — these are the metrics that matter. Every deal comes with quantified analysis, not marketing speak.'
  }, {
    icon: ShieldCheckIcon,
    title: 'No Cold Calls. No Spam.',
    description: "We don't chase you. When you're ready to engage, you'll reach out. Our philosophy is simple: the quality of our deals speaks for itself."
  }, {
    icon: UserCheckIcon,
    title: "We Don't Ask for Your Name or Phone",
    description: "Here's why: we have no reason to reach out to you unless you initiate. The survey is anonymous. You control the relationship. When you see something worth your time, you'll contact us."
  }];
  return <section className="py-24 bg-white" data-id="element-286">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-288">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-navy mb-6" data-id="element-289">
            What Is Cabo Deal Flow?
          </h2>
          <p className="text-xl text-slate max-w-3xl mx-auto" data-id="element-290">
            A privacy-first, data-driven approach to real estate investment in
            Cabo San Lucas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-291">
          {principles.map((principle, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-lg border border-gray-200 hover:border-gold transition-colors" data-id="element-292">
              <principle.icon className="text-gold mb-4" size={40} data-id="element-293" />
              <h3 className="text-2xl font-serif font-semibold text-navy mb-3" data-id="element-294">
                {principle.title}
              </h3>
              <p className="text-slate leading-relaxed" data-id="element-295">
                {principle.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}